import { AppStore } from '@common/stores';
import { ContextWrapper } from './ContextWrapper';

export const AppStoreContextWrapper = new ContextWrapper<AppStore>();
